// extracted by mini-css-extract-plugin
module.exports = {"black":"contact-module--black--2rcJg","___gatsby":"contact-module--___gatsby--lEKFh","contact__info":"contact-module--contact__info--2WLr1"};